import React from "react";

import * as S from "../styled";
import { ModalContext } from "../SuccessMessageModal";

function Text(props) {
  return (
    <ModalContext.Consumer>
      {context => <S.ModalText {...props} layout={context.layout} />}
    </ModalContext.Consumer>
  );
}

export default Text;
